/* eslint-disable import/no-anonymous-default-export */
import MainLayout from "../../../_components/Common/MainLayout";
import { Container, Spinner, Dropdown } from "react-bootstrap";
import useAssessmentList from "./useAssessmentList";
import { dateDiff } from "../../../_helpers/dateFormatter";
import ShareLink from "../../../_uiComponents/ShareLink";
import useCopyToClipboard from "../../../_hooks/useCopyToClipboard";
import { appRoutes } from "../../../_routes/app-routes";
export default () => {
  const {
    loading,
    allAssessmentKits,
    selectedFilter,
    outerClickRef,
    handleFilterChange,
    onEditKitClick,
    onViewCandidatesClick,
    onClickNewAssessment,
    onAssessmentShareClick,
  } = useAssessmentList();

  const { getWebUrl } = useCopyToClipboard();

  return (
    <MainLayout
      activeMenuItem="Assessment Kit"
      pageName={"Assessment Kits"}
    >
      <Container className="footer-gap" ref={outerClickRef}>
        <div className="applied-job-board">
          <div className="hiring-process-dashboard kanban-board-main">
            <div className="row mb-3 mb-md-0">
              <div className="col-lg-6">
                {/* <div className="custom-search-box ml-auto ">
                      <div className="search-box-with-icon shadow-sm">
                        <span className="icon">
                          <img
                            src="/assets/images/search-lg-icon.svg"
                            alt="search"
                          />
                        </span>
                        <input type="text" placeholder="Search" />
                      </div>
                    </div> */}
              </div>
              <div className="col-lg-6 d-flex justify-content-end">
                  <button
                    className="btn btn-primary mb-2 py-2"
                    onClick={() => onClickNewAssessment()}
                  >
                    Create New Assessment
                  </button>
                <Dropdown>
                  <Dropdown.Toggle
                    variant=""
                    className="btn-white-new py-2 shadow-sm text-capitalize"
                  >
                    <img
                      src="/assets/images/filter-lines.svg"
                      alt="filter"
                      className="mr-2"
                    />
                    {selectedFilter}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div
                      onClick={() => handleFilterChange("publish", "Published")}
                      className="dropdown-item cursor-pointer"
                      data-rr-ui-dropdown-item
                    >
                      Published{" "}
                    </div>
                    <div
                      onClick={() => handleFilterChange("draft", "Drafted")}
                      className="dropdown-item cursor-pointer"
                      data-rr-ui-dropdown-item
                    >
                      Drafted
                    </div>

                    <div
                      onClick={() => handleFilterChange("archived", "Archived")}
                      className="dropdown-item cursor-pointer"
                      data-rr-ui-dropdown-item
                    >
                      Archived
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            {loading ? (
              <>
                <div className="d-flex align-items-center justify-content-center p-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              </>
            ) : (
              <>
                {Array.isArray(allAssessmentKits) &&
                  allAssessmentKits.length ? (
                  <>
                    <div className="row">
                      {Array.isArray(allAssessmentKits) &&
                        allAssessmentKits.map((item) => (
                          <div className="col-md-6 mb-4">
                            <div className="d-flex flex-column p-4 bg-white border position-relative h-100 border-radius-10">
                              <div className="upper">
                                <div className="d-flex justify-content-between">
                                  <div className="job-info">
                                    <h3 className="text-dark mb-1 text-capitalize ">
                                      {item?.title}
                                    </h3>
                                  </div>

                                  <div className="d-flex align-items-center">
                                    <button
                                      className="bg-transparent border-0 text-dark"
                                      title="Edit"
                                      onClick={() => onEditKitClick(item?.id)}
                                    >
                                      <img
                                        src="/assets/images/edit-grey.svg"
                                        alt="edit"
                                      />
                                    </button>

                                    <button
                                      className="bg-transparent border-0 text-dark"
                                      title="Copy"
                                      onClick={() =>
                                        onAssessmentShareClick(item?.hash_id)
                                      }
                                    >
                                      <img
                                        src="/assets/images/copy-icon.svg"
                                        alt="edit"
                                      />
                                    </button>
                                  </div>
                                </div>

                                <div className="mb-2">
                                  <div className="d-flex align-items-center fs-smallest  justify-content-between">
                                    <p className="text-grey-4 mb-0">
                                      {Array.isArray(item?.skills) && (
                                        <span className="border rounded-lg p-1 mr-2 d-inline-block">
                                          Skills{" "}
                                          <span className="font-weight-medium text-dark bg-grey rounded-lg py-1 px-2">
                                            {item?.skills &&
                                              item?.skills.length}
                                          </span>{" "}
                                        </span>
                                      )}
                                      <span className="border rounded-lg p-1 d-inline-block">
                                        Questions{" "}
                                        <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                                          {item?.total_questions}
                                        </span>{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center flex-wrap fs-smallest mb-2">
                                  <p className="mr-2 text-capitalize mb-0">
                                    {Array.isArray(item?.skills) &&
                                      item?.skills.map((skill) => (
                                        <span className="border rounded py-1  my-1 bg-grey-3 px-1 d-inline-block fs-smallest mr-2">
                                          {skill?.skill_id &&
                                            skill?.skill_id?.skill}
                                        </span>
                                      ))}
                                  </p>
                                </div>
                                {item?.additional_notes && (
                                  <p className="fs-smallest mb-2">
                                    <strong>Addtional Notes</strong>:
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item?.additional_notes,
                                      }}
                                    />
                                  </p>
                                )}

                                <div className="mb-3">
                                  <ShareLink
                                    link={`${getWebUrl()}${appRoutes.assessementKit.assessmentPublicDetails.replace(
                                      ":id",
                                      item?.hash_id
                                    )}`}
                                    message={`Jigsaw has sent an invite of an Assessment kit, please check the link`}
                                  />
                                </div>
                              </div>
                              <div className="d-flex pt-2 justify-content-between align-items-center border-top  flex-md-wrap flex-lg-nowrap mt-auto">
                                <p className="mb-0 mr-2  text-grey-4 fs-smallest">
                                  Created{" "}
                                  {dateDiff(item?.created_at, new Date())} ago
                                </p>

                                {item?.status === "publish" && (
                                  <div className="job-bottom d-flex align-items-center justify-content-between ">
                                    <button
                                      onClick={() =>
                                        onViewCandidatesClick(item?.id)
                                      }
                                      className="border-0 bg-transparent text-primary py-0 mr-2 cursor-pointer text-nowrap font-weight-medium fs-smallest"
                                    >
                                      View Candidates
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  <div className="text-center pt-5">
                    <img src={"/assets/images/warning.png"} alt="error" />
                    <h3 className="text-danger mb-4">
                      No Assessment Kit is {selectedFilter}
                    </h3>
                      <button
                        className="btn btn-primary"
                        onClick={() => onClickNewAssessment()}
                      >
                        Create A New AssessmentKit
                      </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Container>
    </MainLayout>
  );
};
